import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import * as firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth } from 'firebase/app';
import { Subject, Observable } from 'rxjs';
import { User } from '../models/users';
import { map, take, tap } from 'rxjs/operators';
import { UtilitiesService } from '../services/utilities.service';
import { Company } from '../models/companies';

const defaultPath = '/dash';

@Injectable()
export class AuthService {
  authUser: any;
  constructor(
    private router: Router,
    public auth: AngularFireAuth,
    private utilitiesService: UtilitiesService
  ) { }

  async signIn(email: string, password: string): Promise<string | null> {
    try {
      this.authUser = await this.auth.signInWithEmailAndPassword(email, password);
      if (this.authUser.user.uid) {
        const myUserAndClient = await this.utilitiesService.getAndStoreData(
          this.authUser.user.uid
        );
        return myUserAndClient.user.id;
      } else {
        return null;
      }
    } catch (err) {
      console.log(err);
      return null;
    }
  }

  async logOut() {
    try {
      localStorage.removeItem('udta');
      localStorage.removeItem('cdta');
      await this.auth.signOut();
      this.router.navigate(['/log-in']);
    } catch (err) {
      console.log(err);
    }
  }

  async sendUserEmailInstructions(email) {
    this.auth.sendPasswordResetEmail(email).then(data => {
      console.log('correo enviado');
      return data;
    }).catch(error => {
      console.log(error);
    });
  }

}
@Injectable()
export class AuthGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    public auth: AngularFireAuth,
    private utilitiesService: UtilitiesService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.auth.user.pipe(
      map((user) => {
        if (user) {
          const myUser = new User(JSON.parse(localStorage.getItem('udta')));
          const myCompany = new Company(JSON.parse(localStorage.getItem('cdta')));
          // console.log({ myUser: myUser, myCompany: myCompany });
          if (!myUser.id || !myCompany.id) {
            this.utilitiesService
              .getAndStoreData(user.uid)
              .then((myData) => {
                // console.log({ myData });
              })
              .catch((err) => {
                console.log(err);
              });
          }
          return true;
        }
        this.router.navigate(['/log-in']);
        return false;
      })
    );
  }
}
@Injectable()
export class LogedInGuardService implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    public auth: AngularFireAuth,
    private utilitiesService: UtilitiesService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.auth.user.pipe(
      map((user) => {
        if (!user) {
          return true;
        }
        const myUser = new User(JSON.parse(localStorage.getItem('udta')));
        const myCompany = new Company(JSON.parse(localStorage.getItem('cdta')));
        if (myUser.id && myCompany.id) {
          this.router.navigate([`/dash`]);
          return false;
        } else {
          this.utilitiesService.getAndStoreData(user.uid).then((myData) => {
            this.router.navigate([`/dash`]);
            return false;
          });
        }
      })
    );
  }
}